export const STRIPE_API_VERSION = '2023-10-16';

export const PAYMENT_METHODS = {
  CARD: 'card',
  BANK_ACCOUNT: 'bank_account',
  SEPA_DEBIT: 'sepa_debit',
  IDEAL: 'ideal',
  SOFORT: 'sofort',
} as const;

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  CANCELED: 'canceled',
  PAST_DUE: 'past_due',
  UNPAID: 'unpaid',
  INCOMPLETE: 'incomplete',
  INCOMPLETE_EXPIRED: 'incomplete_expired',
  TRIALING: 'trialing',
} as const;

export const INVOICE_STATUS = {
  DRAFT: 'draft',
  OPEN: 'open',
  PAID: 'paid',
  UNCOLLECTIBLE: 'uncollectible',
  VOID: 'void',
} as const;

export const CHECKOUT_MODE = {
  PAYMENT: 'payment',
  SUBSCRIPTION: 'subscription',
  SETUP: 'setup',
} as const;

export const BILLING_INTERVALS = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
} as const;

export const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  CAD: 'C$',
  AUD: 'A$',
  CHF: 'CHF',
  CNY: '¥',
  SEK: 'kr',
  NZD: 'NZ$',
} as const;

export const DEFAULT_CURRENCY = 'USD';

export const WEBHOOK_EVENTS = {
  CUSTOMER_SUBSCRIPTION_CREATED: 'customer.subscription.created',
  CUSTOMER_SUBSCRIPTION_UPDATED: 'customer.subscription.updated',
  CUSTOMER_SUBSCRIPTION_DELETED: 'customer.subscription.deleted',
  INVOICE_PAYMENT_SUCCEEDED: 'invoice.payment_succeeded',
  INVOICE_PAYMENT_FAILED: 'invoice.payment_failed',
  CHECKOUT_SESSION_COMPLETED: 'checkout.session.completed',
  PAYMENT_INTENT_SUCCEEDED: 'payment_intent.succeeded',
  PAYMENT_INTENT_PAYMENT_FAILED: 'payment_intent.payment_failed',
} as const;

export const ERROR_MESSAGES = {
  PROVIDER_NOT_CONFIGURED: 'Payments provider is not properly configured',
  STRIPE_NOT_LOADED: 'Stripe has not been loaded yet',
  INVALID_PRICE_ID: 'Invalid price ID provided',
  INVALID_CUSTOMER_ID: 'Invalid customer ID provided',
  CHECKOUT_FAILED: 'Checkout session creation failed',
  PAYMENT_FAILED: 'Payment processing failed',
  SUBSCRIPTION_NOT_FOUND: 'Subscription not found',
  CUSTOMER_NOT_FOUND: 'Customer not found',
} as const;
